<div class="about-section">
    <div class="container">
        <div class="row align-items-center m-1">
            <!-- Left Side: Text -->
            <div class="col-md-7 col-12 about-text">
                <h2>The Yoga Program</h2>
                <!-- <h3>Diverse Avenues for Discovery and Growth</h3> -->
                <p>
                    The Yoga Program at Innovative Vision is a powerful tool for holistic development, deeply integrated
                    into our curriculum to nurture a child's inner world. Beyond physical postures, it is a practice
                    that promotes mindfulness, self-awareness, and emotional balance, ensuring that we address the
                    crucial mind and soul aspects of a child's growth.
                </p>
            </div>
            <!-- Right Side: Image -->
            <div class="col-md-5 col-12 text-center about-img">
                <img src="assets/ivimg/programDetails/yogaH.svg" alt="Girl Learning Pottery" class="img-fluid">
            </div>
        </div>
    </div>
</div>
<div class="key-focus-section m-3">
    <div class="image-container">
        <img src="assets/ivimg/programDetails/yogaF.svg" alt="Key Focus Areas"/>
    </div>
    <div class="content">
        <h2 class="section-title">Key Focus Areas</h2>
        <div class="points">
            <p>
                <strong>1. Body & Mind Connection:</strong> Through gentle postures (asanas) and conscious breathing
                exercises (pranayama), children learn to connect with their bodies and calm their minds. This practice
                enhances their body awareness, concentration, and ability to stay present in the moment.
            </p>
            <p>
                <strong>2. Emotional Regulation:</strong> Yoga provides children with valuable tools to manage their
                emotions. By learning to focus on their breath and a particular pose, they develop self-regulation
                skills that can help them navigate stress and anxiety, fostering a sense of inner peace.
            </p>
            <p>
                <strong>3. Flexibility & Strength:</strong> While the focus is on the inner journey, the physical
                practice of yoga significantly improves a child's flexibility, balance, and core strength. It is a
                gentle yet effective way to maintain a healthy body and posture
            </p>
        </div>
    </div>
</div>


<div class="program-highlights">
    <div class="highlight-container">
        <!-- Image from assets -->
        <div class="image-container">
            <img src="assets/ivimg/PD-2.svg" alt="Program Highlights" />
        </div>


        <!-- Text Content -->
        <div class="text-container">
            <h2 class="title">Program Highlights</h2>
            <p>
                <strong>Playful & Imaginative Sessions:</strong> Our yoga sessions are designed to be fun and engaging.
                We use stories, animal poses, and creative themes to make the practice enjoyable and accessible for
                young children, encouraging them to see yoga as a form of playful exploration.
            </p>
            <p>
                <strong>Qualified Instructors: </strong> Our classes are led by certified yoga instructors who are
                trained in child development. They create a supportive and non-competitive environment where every child
                feels safe to explore their own pace and abilities.
            </p>
            <p>
                <strong>Fostering a Calm Environment:</strong> We understand the importance of providing a tranquil
                space. Our sessions are conducted in a calm setting, often accompanied by soft, ambient music, to help
                children unwind and connect with their inner selves.
            </p>
        </div>
    </div>
</div>


<div class="benefits-section">
    <h2 class="benefits-title">Benefits for Your Child</h2>
    <p class="benefits-text">
        Our yoga program offers a unique set of benefits that are essential for a child's well-being in today's
        fast-paced world. It helps them develop better concentration, manage their emotions, and build a strong sense of
        inner peace. The physical aspects of the practice improve their flexibility and strength, while the meditative
        nature of yoga boosts their emotional intelligence and resilience. This program is a journey inward, equipping
        your child with the tools they need to live a balanced, mindful, and joyful life.
    </p>
</div>